<template>
  <div class="step-connector d-flex flex-column align-items-center my-1">
    <div class="connector-line" :class="lineClass"></div>
    <span class="connector-chip category-chip" :class="chipClass">{{ label }}</span>
    <div class="connector-line" :class="lineClass"></div>
  </div>
</template>

<script>
export default {
  name: 'StepConnector',
  props: {
    state: { type: String, default: 'seq' }, // 'seq' | 'linked' | 'detached' | 'warning' | 'loop'
    label: { type: String, default: '↓ Next Step' }
  },
  computed: {
    lineClass () {
      if (this.state === 'loop') {
        return 'connector-line-loop'
      }
      if (this.state === 'warning') {
        return 'connector-line-warning'
      }
      if (this.state === 'linked') {
        return 'connector-line-linked'
      }
      if (this.state === 'detached') {
        return 'connector-line-detached'
      }
      return 'connector-line-seq'
    },
    chipClass () {
      if (this.state === 'loop') {
        return 'category-chip-danger'
      }
      if (this.state === 'warning') {
        return 'category-chip-warning'
      }
      if (this.state === 'linked' || this.state === 'detached') {
        return 'category-chip-linked'
      }
      return 'category-chip-default'
    }
  }
}
</script>

<style scoped>
.connector-line {
  width: 2px;
  height: 14px;
  background: #ddd;
}
.connector-line-seq {
  background: #ddd;
}
.connector-line-linked {
  background: #00518d;
}
.connector-line-detached {
  background: none;
  border-left: 2px dashed #ccc;
  width: 0;
  opacity: .6;
}
.connector-line-warning {
  background: #ffc107;
}
.connector-line-loop {
  background: #dc3545;
  animation: connector-pulse 1.4s ease-in-out infinite;
}
@keyframes connector-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
.category-chip {
  display: inline-block;
  border-radius: 0.5em;
  padding: .15em .7em;
  font-size: .75em;
  font-weight: 700;
  margin: 2px 0;
  white-space: nowrap;
}
.category-chip-default {
  background-color: #f5f5f5;
  color: #666666;
}
.category-chip-linked {
  background-color: #e5f2ff;
  color: #00518d;
}
.category-chip-warning {
  background-color: #fdf3e0;
  color: #8c5429;
}
.category-chip-danger {
  background-color: #fae1e3;
  color: #89151c;
}
</style>
